import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useMemo } from 'react';
import { isAndroidApp } from 'webui/utils/version';
import { format_price_x100, is_paid_tariff } from 'console/billing/billing-utils';
import { ErrorBoundary } from 'shared/components/error-boundary';
import { Alert, alpha, Box, Button, Skeleton, useTheme } from '@mui/material';
import { BillingPayCard } from 'console/billing/widgets';
import { useFetch } from 'shared/api/hooks';
import { LocalShippingRounded, ShoppingCartRounded } from '@mui/icons-material';
import { TariffHeader } from 'console/sim/shared/compare-tariff/tariff-header';
import { useParams } from 'react-router-dom';
import { SimOrderStepper } from 'console/sim/order-sim/stepper';
import { useAppSelector } from 'shared/hooks/redux/hooks';
import { SimOrderForm } from 'console/sim/order-sim/order-form';
import { useNavigateBack } from 'shared/hooks/router';
function on_not_enough_text(amount_x100, tariff_pro) {
    if (isAndroidApp() && !tariff_pro) {
        return 'Заказать сим-карту';
    }
    return `Оплатить доставку ${format_price_x100(amount_x100)}`;
}
export const SimOrder = memo(function SimOrder() {
    const { tariff_id } = useParams();
    const _tariff_id = tariff_id;
    const backStep = useNavigateBack();
    const [isLoading, response_price, error_price] = useFetch('get_prices');
    const tariff_pro = useAppSelector(is_paid_tariff);
    const theme = useTheme();
    const color = useMemo(() => tariff_id == 'base'
        ? theme.palette.primary.main
        : theme.palette.primary.dark, [tariff_id, theme]);
    return (_jsx(ErrorBoundary, { children: _jsxs(Box, { display: "flex", flexDirection: "column", gap: 2, p: 2, children: [isLoading ? (_jsx(Skeleton, { children: _jsx(TariffHeader, { id: _tariff_id, title: "???", variant: "outlined" }) })) : response_price != null ? (_jsx(TariffHeader, { id: _tariff_id, title: response_price?.sim_tariffs.find(({ id }) => id == _tariff_id)
                        ?.title ?? '????', variant: "outlined", children: _jsx(Button, { onClick: backStep, sx: {
                            color,
                            border: `1px solid ${color}`,
                            '&:hover, &.Mui-focusVisible': {
                                border: `1px solid ${color}`,
                                backgroundColor: alpha(theme.palette.primary.light, 0.1),
                            },
                        }, size: "small", variant: "outlined", children: "\u0418\u0437\u043C\u0435\u043D\u0438\u0442\u044C" }) })) : null, _jsx(SimOrderForm, { payButton: (order_state, onPreCheck) => isLoading ? (_jsx(Skeleton, { children: _jsx(Button, { variant: "contained", startIcon: _jsx(ShoppingCartRounded, {}), children: "\u041F\u043E\u043F\u043E\u043B\u043D\u0438\u0442\u044C \u043D\u0430 100 \u0438 \u043E\u043F\u043B\u0430\u0442\u0438\u0442\u044C \u0434\u043E\u0441\u0442\u0430\u0432\u043A\u0443" }) })) : response_price != null ? (_jsx(BillingPayCard, { pay_props: {
                            price_x100: response_price.sim_shipping_x100,
                            pay_intent: {
                                type: 'sim_shipping',
                                operator: order_state.operator,
                                fio: order_state.fio,
                                phone: order_state.phone,
                                postindex: order_state.postindex,
                                address: order_state.address,
                                tariff: _tariff_id ?? 'big',
                            },
                            button_props: {
                                startIcon: _jsx(LocalShippingRounded, {}),
                                color: 'info',
                            },
                            onPreCheck,
                            enough_text: 'Оформить доставку',
                            not_enough_text: (amount_x100) => on_not_enough_text(amount_x100, tariff_pro),
                        }, sx: {
                            width: '100%',
                        }, success_message: "\u041E\u043F\u043B\u0430\u0442\u0430 \u043F\u0440\u043E\u0448\u043B\u0430 \u0443\u0441\u043F\u0435\u0448\u043D\u043E! \u041C\u044B \u043E\u0442\u043F\u0440\u0430\u0432\u0438\u043C \u0432\u0430\u043C \u0441\u0438\u043C-\u043A\u0430\u0440\u0442\u0443 \u0432 \u0431\u043B\u0438\u0436\u0430\u0439\u0448\u0435\u0435 \u0432\u0440\u0435\u043C\u044F" })) : (_jsx(Alert, { severity: "error", children: error_price })) }), _jsx(SimOrderStepper, { step_id: 1 })] }) }));
});
